
import React, { useState, lazy, } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { 
  Header,
  Footer,
  Features, 
  Contact, 
  Privacy,
  Refund, 
   Terms,
} from './components';

const Home = lazy(() => import('./pages/Home'));
const Plans = lazy(() => import('./pages/Plans'));
const Services = lazy(() => import('./pages/Services'));
const Blog = lazy(() => import('./pages/Blog'));
const SinglePost = lazy(() => import('./pages/SinglePost'));
const About = lazy(() => import('./pages/About'));
const Error = lazy(() => import('./pages/Error'));



function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="App">
      <BrowserRouter>
        <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        <main className="main-content">
          
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/services" element={<Services />} />
            <Route path="/features" element={<Features />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<SinglePost />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="/refund-and-cancellation-policy" element={<Refund />} />
            <Route path="*" element={<Error />} />
            </Routes>
          
        </main>

        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;